import React, { useEffect, useState } from "react";

const CountdownTimer = ({ epochTime, setIsTimerExpired }) => {
  const calculateTimeLeft = () => {
    const now = Math.floor(Date.now() / 1000); // current time in seconds
    const difference = epochTime - now;
    return difference > 0 ? difference : 0;
  };

  const [secondsLeft, setSecondsLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    // Recalculate immediately when epochTime changes
    setSecondsLeft(calculateTimeLeft());

    const timer = setInterval(() => {
      const timeLeft = calculateTimeLeft(); // Recalculate from actual time
      setSecondsLeft(timeLeft);

      if (timeLeft <= 0) {
        setIsTimerExpired(true);
        clearInterval(timer);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [epochTime]); // Add epochTime as dependency

  const formatTime = (seconds) => {
    const days = Math.floor(seconds / (24 * 3600));
    const hours = Math.floor((seconds % (24 * 3600)) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    // Add leading zeros for better formatting
    return `${days}D ${hours.toString().padStart(2, "0")}H ${minutes
      .toString()
      .padStart(2, "0")}M ${secs.toString().padStart(2, "0")}S`;
  };

  return <h3>{formatTime(secondsLeft)}</h3>;
};

export default CountdownTimer;
